import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { Observable } from 'rxjs';
import { ENV_TOKEN } from '../../app-module.token';

export interface EnvioCorreoMasivoRequest {
  idsOrganismos: number[];
}

export interface DetalleEnvio {
  idOrganismo: number;
  nombreOrganismo: string;
  correo: string;
  enviado: boolean;
  mensajeError: string | null;
}

export interface EnvioCorreoMasivoResponse {
  succcess: boolean;
  data: {
    totalProcesados: number;
    totalEnviados: number;
    totalErrores: number;
    detalles: DetalleEnvio[];
  };
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class EnvioCorreoMasivoService {
  public constService: any;
  urlRaiz!: string;
  private httpService: HttpService = inject(HttpService);
  readonly environment = inject(ENV_TOKEN);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Envía correos masivos a las autoridades seleccionadas
   * @param request - Objeto con los IDs de organismos
   * @returns Observable con la respuesta del servicio
   */
  enviarCorreosMasivos(request: EnvioCorreoMasivoRequest): Observable<EnvioCorreoMasivoResponse> {
    const funcion = "icoij/sendMassEmail";
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request) as Observable<EnvioCorreoMasivoResponse>;
  }
}
